module.exports = __webpack_public_path__ + "img/basic-browser.782aa009.svg";